import React from 'react'
import './Footer.css';

import logoMinistere from '../assets/ministere.png';
import logoAgenceDuSport from '../assets/agence_du_sport.png';
import logoCreditMutuel from '../assets/credit_mutuel.png';
import logoTibhar from '../assets/tibhar.png';
import leapmotor from '../assets/leapmotor.png';
import logoCornilleau from '../assets/cornilleau.png';
import logoDonic from '../assets/donic.png';
import logoGerflor from '../assets/gerflor.png';
import logoLequipe from '../assets/lequipe.png';

// Icones
import {
    BsTwitterX,
    BsInstagram,
    BsYoutube
} from 'react-icons/bs';

import { FaFacebookF } from 'react-icons/fa'
import { useLocation, NavLink } from 'react-router-dom';

function Footer() {
    const location = useLocation();
    const classeLocation =  location.pathname.split('/')[1];

    const openWindow = (link) => {
        window.open(link, '_blank');
    }

    return ( 
        <div className="footer_component">
            
            <div className={"footer_socials_medias " + classeLocation}>
                <span style={{marginRight: 10}}>Suivez nous sur</span>
                <a href="https://x.com/ffttofficiel" target="_blank">
                    <BsTwitterX size={24} color='white' style={{cursor: 'pointer'}} />
                </a>
                <a href="https://www.instagram.com/ffttofficiel" target="_blank">
                    <BsInstagram size={24} color='white' style={{cursor: 'pointer'}} />
                </a>
                <a href="https://www.facebook.com/FFTTofficiel" target="_blank">
                    <FaFacebookF size={24} color='white' style={{cursor: 'pointer'}} />
                </a>
                <a href="https://www.youtube.com/channel/UC6hHKx0z0enl5RnKnrOrmfw" target="_blank">
                    <BsYoutube size={24} color='white' style={{cursor: 'pointer'}} />
                </a>
            </div>
            <div className="footer_partenaires">
                <div className="footer_partenaires_images">
                    <span className={'footer_span_partenaires ' + classeLocation}>Partenaires officiels</span>
                    <div className="footer_logos_row">
                        <img className="footer_logo_white_bg" src={logoMinistere} onClick={()=>openWindow('https://www.jeunes.gouv.fr/la-ministre-des-sports-de-la-jeunesse-et-de-la-vie-associative-2437')} />
                        <img src={logoAgenceDuSport} onClick={()=>openWindow('https://www.agencedusport.fr/')} />
                        <img src={logoCreditMutuel} onClick={()=>openWindow('https://www.creditmutuel.fr/home/index.html')} />
                        <img src={logoTibhar} onClick={()=>openWindow('https://tibhar.info/home/')} />
                        <img src={leapmotor} onClick={()=>openWindow('https://www.leapmotor.net/fr')} />
                        <img src={logoCornilleau} onClick={()=>openWindow('https://fr.cornilleau.com/')} />
                        <img src={logoDonic} onClick={()=>openWindow('https://www.donic.com/fr/')} />
                        <img src={logoGerflor} onClick={()=>openWindow('https://www.gerflor.fr/')} />
                        <img src={logoLequipe} onClick={()=>openWindow('https://www.lequipe.fr/')} />
                    </div>
                </div>
            </div>
            <section className="footer_links">
                <div className="footer_links_wrapper">
                    <ul className="footer_links_nav">
                        <li>
                            <a href="https://www.fftt.com/site/articles/mentions-legales" target="_blank">Mentions légales</a>
                        </li>
                        <li>
                            <a href="https://www.fftt.com/site/contactez-nous" target="_blank">Contact</a>
                        </li>
                        <li>
                            <NavLink to="/docs">Documentation</NavLink>
                        </li>
                    </ul>
                    <ul className="footer_links_mentions">
                        <li>Copyright FFTT PRO 2026</li>
                    </ul>
                </div>
            </section>
        </div>
    );
}

export default Footer;
